// NOTE: Do not add any external dependency here! This util is used inside independent "bettingLoader".

const ADAPTED_LOCALE_CONST = {
    cn: 'zh',
    zh_CN: 'zh',
    ua: 'uk',
    'uk-ua': 'uk',
    uk_UA: 'uk',
};

const ADAPTED_LOCALE: ExtraProps<
    typeof ADAPTED_LOCALE_CONST
> = ADAPTED_LOCALE_CONST;

function adaptBettingOptions(
    bettingOptions: APIBettingOptions
): BettingOptions {
    const {
        currency,
        isAuthorized,
        locale,
        rootElement,
        selectedSportIds,
        sportIds,
        token,
        tournamentIds,
        url: {
            static_endpoint,
            public_sv,
            bettingPath,
            pagePath,
            gqlEndpoint = public_sv,
            staticEndpoint = static_endpoint,
        },
    } = bettingOptions;

    const adaptedLocale = ADAPTED_LOCALE[locale] || locale;

    const adaptedSelectedSportIds =
        !selectedSportIds || !selectedSportIds.length
            ? sportIds
            : selectedSportIds;

    return {
        url: {
            gqlEndpoint,
            staticEndpoint,
            pagePath,
            bettingPath,
            static_endpoint: staticEndpoint,
            public_sv: gqlEndpoint,
        },
        currency,
        locale: adaptedLocale,
        sportIds,
        tournamentIds,
        token,
        rootElement,
        isAuthorized,
        selectedSportIds: adaptedSelectedSportIds,
    };
}

export default adaptBettingOptions;
